import bitgetLogo from './assets/bitget.jpg';
import indodaxLogo from './assets/indodax.jpg';

export const TRADER_TYPES = [
  { id: 'day', label: 'Day Trader', description: 'Multiple trades daily', icon: 'Clock' },
  { id: 'swing', label: 'Swing Trader', description: 'Per-week trades', icon: 'TrendingUp' },
  { id: 'long', label: 'Long-term Holder', description: 'Strategic portfolio growth', icon: 'Infinity' },
];

export const GOALS = [
  { id: 'track', label: 'Track PnL', description: 'Real-time profit and loss monitoring across wallets', icon: 'Target' },
  { id: 'improve', label: 'Improve Strategy', description: 'Journal trades and identify winning patterns', icon: 'Compass' },
  { id: 'analyze', label: 'Analyze Performance', description: 'Deep dive into drawdown and risk-adjusted returns', icon: 'BarChart' },
];

export const SOURCES = [
  { id: 'google', label: 'Google Search', icon: 'Search' },
  { id: 'tiktok', label: 'Tiktok', icon: 'Music2' },
  { id: 'instagram', label: 'Instagram', icon: 'Instagram' },
  { id: 'twitter', label: 'Twitter', icon: 'Twitter' },
  { id: 'youtube', label: 'YouTube', icon: 'Youtube' },
  { id: 'community', label: 'Community/Membership', icon: 'Users' },
  { id: 'other', label: 'Other', icon: 'MoreHorizontal' },
];

export const PLANS = [
  { 
    id: 'free', 
    name: 'Free', 
    price: 'IDR 0', 
    subtitle: 'Basic Tracking',
    features: ['1 Week Free Trial of Pro Package'],
    cta: 'Start Free'
  },
  { 
    id: 'pro', 
    name: 'Pro', 
    price: 'IDR 99.000', 
    subtitle: 'For Active Traders',
    mostPopular: true,
    features: ['Auto-Sync API', 'Calendar Daily Journal', 'Add Manually Your Trades', 'Multi-Variable Analytics', 'Portfolio Analytics'],
    cta: 'Upgrade Now'
  },
  { 
    id: 'premium', 
    name: 'Premium', 
    price: 'IDR 179.000', 
    subtitle: 'For Advance Traders',
    features: ['All Pro Features', 'Dashboard Catat Crypto Score', 'Personalize A.I Assistant (Beta)', 'Early Access for New Features'],
    cta: 'Go Premium'
  },
];

export const EXCHANGES = [
  { id: 'binance', name: 'Binance', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/270.png', color: '#F3BA2F' },
  { id: 'bitget', name: 'Bitget', icon: bitgetLogo, color: '#00F0FF' },
  { id: 'mexc', name: 'MEXC', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/544.png', color: '#0066FF' },
  { id: 'ajaib', name: 'Ajaib', icon: 'https://avatars.githubusercontent.com/u/47547963?s=200&v=4', color: '#00A859' },
  { id: 'okx', name: 'OKX', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png', color: '#000000' },
  { id: 'bybit', name: 'Bybit', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/521.png', color: '#F7A600' },
  { id: 'luno', name: 'Luno', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/102.png', color: '#1224F5' },
  { id: 'coinbase', name: 'Coinbase', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/89.png', color: '#0052FF' },
  { id: 'tokocrypto', name: 'Tokocrypto', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/525.png', color: '#DA251C' },
  { id: 'indodax', name: 'Indodax', icon: indodaxLogo, color: '#1B2C68' },
  { id: 'pintu', name: 'Pintu', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/1123.png', color: '#000000' },
  { id: 'pluang', name: 'Pluang', icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAn1BMVEVGPP/v6ufx7Ob18OVEOv/38uX07+bw6+bu6edCOP81Kf85Lv88Mf80KP/59OVANf/f2unBu+7p5OeJgvbSzOvY0urk3+jHwe1US/y0rvDMxuwwI/+Ce/e5s++vqfHc1+mmoPKOh/V6cvhrY/q9t+5vZ/liWfuXkfRLQf1aUfx2bvloYPqemPPJw+1RSP2wqvF+d/egmvOTjPVjWvohEP9gZ4AuAAAMOUlEQVR4nO2deXuiPBDAJSSBkEAUz4rWu561tn2//2d7oWY4rIJtXaF98vuru4/rZphkrszQWk2j0Wg0Go1Go9FoNBqNRqPRaDQajUaj0Wg0Go1Go9FoNBqNRqPR/GX+B0TktQettIdWAAAAAElFTkSuQmCC', color: '#FEDD00' },
  { id: 'triv', name: 'Triv', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/1196.png', color: '#0066CC' },
  { id: 'upbit', name: 'Upbit', icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/351.png', color: '#0062C4' },
];


// CEX Configuration for Multi-CEX Feature
export interface CexConfig {
  value: string;
  label: string;
  requiresPassphrase: boolean;
  icon?: string;
  color?: string;
}

export const SUPPORTED_CEX: CexConfig[] = [
  { value: 'binance', label: 'Binance', requiresPassphrase: false, icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/270.png', color: '#F3BA2F' },
  { value: 'bybit', label: 'Bybit', requiresPassphrase: false, icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/521.png', color: '#F7A600' },
  { value: 'okx', label: 'OKX', requiresPassphrase: true, icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png', color: '#000000' },
  { value: 'mexc', label: 'MEXC', requiresPassphrase: false, icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/544.png', color: '#0066FF' },
  { value: 'bitget', label: 'Bitget', requiresPassphrase: true, icon: bitgetLogo, color: '#00F0FF' },
  { value: 'indodax', label: 'Indodax', requiresPassphrase: false, icon: indodaxLogo, color: '#1B2C68' },
  { value: 'tokocrypto', label: 'Tokocrypto', requiresPassphrase: false, icon: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/525.png', color: '#DA251C' },
  { value: 'manual', label: 'Manual / Virtual Journal', requiresPassphrase: false, icon: 'https://cdn-icons-png.flaticon.com/512/2639/2639684.png', color: '#EC4899' },
];

export interface CexAccount {
  id: number;
  cex_name: string;
  cex_display_name: string;
  account_label: string;
  full_display_name: string;
  is_active: boolean;
  last_synced_at: string | null;
  created_at: string;
}

export const POPULAR_PAIRS = [
  { symbol: 'BTCUSDT', base: 'BTC', quote: 'USDT', label: 'Bitcoin / Tether' },
  { symbol: 'ETHUSDT', base: 'ETH', quote: 'USDT', label: 'Ethereum / Tether' },
  { symbol: 'SOLUSDT', base: 'SOL', quote: 'USDT', label: 'Solana / Tether' },
  { symbol: 'BNBUSDT', base: 'BNB', quote: 'USDT', label: 'BNB / Tether' },
  { symbol: 'XRPUSDT', base: 'XRP', quote: 'USDT', label: 'Ripple / Tether' },
  { symbol: 'ADAUSDT', base: 'ADA', quote: 'USDT', label: 'Cardano / Tether' },
  { symbol: 'DOGEUSDT', base: 'DOGE', quote: 'USDT', label: 'Dogecoin / Tether' },
  { symbol: 'AVAXUSDT', base: 'AVAX', quote: 'USDT', label: 'Avalanche / Tether' },
  { symbol: 'DOTUSDT', base: 'DOT', quote: 'USDT', label: 'Polkadot / Tether' },
  { symbol: 'LINKUSDT', base: 'LINK', quote: 'USDT', label: 'Chainlink / Tether' },
  { symbol: 'MATICUSDT', base: 'MATIC', quote: 'USDT', label: 'Polygon / Tether' },
  { symbol: 'NEARUSDT', base: 'NEAR', quote: 'USDT', label: 'Near Protocol / Tether' },
];
